import { getDefaultWorkflowErrorMessage } from 'hooks/useWorkflowErrorsUtils';
import { NextWorkflowError } from 'models/NextWorkflowError';

export function getFunctionnalErrorMessage(rejections: readonly NextWorkflowError[] | null | undefined): string | null {
  const messages: string[] = rejections?.map(r => getDefaultWorkflowErrorMessage(r))?.filter(x => x !== null) ?? [];
  if (messages.length === 0) {
    return null;
  }
  if (messages.length === 1) {
    return messages[0];
  }
  return messages.join(', ');
}
